import { Component } from '@angular/core';

@Component({
  selector: 'era-panel',
  templateUrl: './panel.component.html',
})
export class PanelComponent {}
